// ── Part definitions & stats for Beyblade customization ──
export const PARTS = {
  layers: {
    striker:  { name: 'Striker',   attack: 9,  defense: 3, stamina: 4, attackType: 'smash',   description: 'Heavy smash blades deliver devastating single impacts' },
    vortex:   { name: 'Vortex',   attack: 6,  defense: 6, stamina: 6, attackType: 'barrage', description: 'Multi-blade turbine delivers rapid barrage hits' },
    dragon:   { name: 'Dragon',   attack: 8,  defense: 5, stamina: 3, attackType: 'upper',   description: 'Dragon claws launch opponents upward on contact' },
    phoenix:  { name: 'Phoenix',  attack: 4,  defense: 8, stamina: 7, attackType: 'barrage', description: 'Dense feather blades create defensive barrage wall' },
    valkyrie: { name: 'Valkyrie', attack: 10, defense: 2, stamina: 3, attackType: 'smash',   description: 'Sword-wings deliver the most powerful smash strikes' },
    achilles: { name: 'Achilles', attack: 7,  defense: 7, stamina: 5, attackType: 'upper',   description: 'Shield-blades angle upward to displace opponents' },
    spriggan: { name: 'Spriggan', attack: 7,  defense: 6, stamina: 6, attackType: 'smash',   description: 'Dual-contact pads deliver balanced smash force' },
    longinus: { name: 'Longinus', attack: 10, defense: 3, stamina: 2, attackType: 'smash',   description: 'Spiral drill-lances focus maximum burst smash power' },
    fafnir:   { name: 'Fafnir',   attack: 3,  defense: 5, stamina: 10, attackType: 'barrage', description: 'Rubber spin-absorb blades create continuous barrage drain' },
    diabolos: { name: 'Diabolos', attack: 8,  defense: 6, stamina: 4, attackType: 'upper',   description: 'Dragon emperor crests uppercut opponents skyward' },
  },
  cores: {
    heavy:    { name: 'Heavy',    weight: 9, stamina: 7, speed: 3, description: 'Maximum weight, hard to knock out' },
    balanced: { name: 'Balanced', weight: 5, stamina: 5, speed: 5, description: 'Equal distribution across all stats' },
    light:    { name: 'Light',    weight: 2, stamina: 3, speed: 9, description: 'Extreme speed, low stability' },
    gravity:  { name: 'Gravity',  weight: 7, stamina: 8, speed: 4, description: 'Center-weighted for spin retention' },
    forge:    { name: 'Forge',    weight: 6, stamina: 6, speed: 6, description: 'Angled fins for air-braking stability' },
    knuckle:  { name: 'Knuckle',  weight: 8, stamina: 5, speed: 4, description: 'Protruding knobs add impact weight' },
    aero:     { name: 'Aero',     weight: 3, stamina: 4, speed: 10, description: 'Winglets create downforce at high speed' },
    magma:    { name: 'Magma',    weight: 10, stamina: 8, speed: 2, description: 'Molten core design, insane weight' },
    vanguard: { name: 'Vanguard', weight: 7, stamina: 6, speed: 5, description: 'Shield plates deflect incoming attacks' },
    blitz:    { name: 'Blitz',    weight: 6, stamina: 4, speed: 8, description: 'Angled edges create burst-resistant lock' },
  },
  tips: {
    attack:   { name: 'Attack',   friction: 8, movement: 9, stability: 3, description: 'Wide flat tip, aggressive movement' },
    stamina:  { name: 'Stamina',  friction: 2, movement: 3, stability: 8, description: 'Sharp point, minimal friction' },
    defense:  { name: 'Defense',  friction: 6, movement: 4, stability: 7, description: 'Rubber tip, holds ground firmly' },
    balance:  { name: 'Balance',  friction: 5, movement: 6, stability: 5, description: 'Semi-flat, versatile performance' },
    jolt:     { name: 'Jolt',     friction: 9, movement: 8, stability: 2, description: 'Spring-loaded chaos, unpredictable' },
    orbit:    { name: 'Orbit',    friction: 3, movement: 5, stability: 9, description: 'Free-spin ring, supreme stamina' },
    destroy:  { name: 'Destroy',  friction: 10, movement: 10, stability: 1, description: 'Massive rubber flat, wild aggression' },
    bearing:  { name: 'Bearing',  friction: 1, movement: 2, stability: 10, description: 'Ball bearing tip, ultimate spin time' },
    xtreme:   { name: 'Xtreme',   friction: 7, movement: 8, stability: 4, description: 'Rubber flat with dash pattern' },
    volcanic: { name: 'Volcanic', friction: 6, movement: 5, stability: 8, description: 'Spring-cushioned ball, absorbs hits' },
  },
  colors: [
    '#e94560', '#4ecdc4', '#a855f7', '#f59e0b',
    '#22c55e', '#3b82f6', '#ec4899', '#ffffff',
    '#ef4444', '#14b8a6', '#8b5cf6', '#f97316',
    '#06b6d4', '#84cc16', '#000000', '#fbbf24',
  ]
};

// Compute overall stats from chosen parts
export function computeStats(layer, core, tip) {
  const l = PARTS.layers[layer];
  const d = PARTS.cores[core];
  const t = PARTS.tips[tip];

  return {
    attack:  Math.min(10, Math.round((l.attack * 0.7 + t.movement * 0.3))),
    defense: Math.min(10, Math.round((l.defense * 0.5 + d.weight * 0.3 + t.stability * 0.2))),
    stamina: Math.min(10, Math.round((l.stamina * 0.3 + d.stamina * 0.4 + t.stability * 0.3))),
    speed:   Math.min(10, Math.round((d.speed * 0.4 + t.movement * 0.4 + (10 - d.weight) * 0.2))),
    weight:  Math.min(10, Math.round(d.weight * 0.7 + l.defense * 0.3)),
  };
}

// Default bey configs
export function defaultBey(playerNum) {
  return {
    layer: playerNum === 1 ? 'striker' : 'dragon',
    core:  playerNum === 1 ? 'heavy'   : 'balanced',
    tip:   playerNum === 1 ? 'attack'  : 'defense',
    color: playerNum === 1 ? '#a855f7' : '#ef4444',
  };
}

// Arena definitions
export const ARENAS = {
  classic: {
    name: 'Classic Stadium',
    radius: 8,
    bowlDepth: 1.8,
    wallHeight: 2,
    friction: 0.98,
    wallBounce: 0.6,
    floorColor: 0x1a1a3e,
    wallColor: 0x3a3a6e,
    rimColor: 0x5a5a9e,
    envColor: 0x0a0a1e,
    lineColor: 0x5555aa,
    centerColor: 0x6666bb,
    outerColor: 0x222244,
    hasLava: false,
    hasIce: false,
    hasWalls: true,
  },
  volcano: {
    name: 'Volcano Pit',
    radius: 7,
    bowlDepth: 2.5,
    wallHeight: 3,
    friction: 0.97,
    wallBounce: 0.5,
    floorColor: 0x3e1a0a,
    wallColor: 0x5e2a1a,
    rimColor: 0x8e3a1a,
    envColor: 0x1a0a00,
    lineColor: 0xff4400,
    centerColor: 0x884411,
    outerColor: 0x331100,
    hasLava: true,
    hasIce: false,
    hasWalls: true,
  },
  ice: {
    name: 'Ice Ring',
    radius: 9,
    bowlDepth: 1.2,
    wallHeight: 1.5,
    friction: 0.995,
    wallBounce: 0.8,
    floorColor: 0x0a2a3e,
    wallColor: 0x1a4a6e,
    rimColor: 0x3a7aae,
    envColor: 0x050a1e,
    lineColor: 0x44bbff,
    centerColor: 0x5599cc,
    outerColor: 0x112233,
    hasLava: false,
    hasIce: true,
    hasWalls: true,
  },
  void: {
    name: 'The Void',
    radius: 10,
    bowlDepth: 0.8,
    wallHeight: 0,
    friction: 0.985,
    wallBounce: 0,
    floorColor: 0x0a0a1e,
    wallColor: 0x0a0a1e,
    rimColor: 0x2a1a4e,
    envColor: 0x000005,
    lineColor: 0x8833ff,
    centerColor: 0x331166,
    outerColor: 0x0a0a15,
    hasLava: false,
    hasIce: false,
    hasWalls: false,
  },
  thunder: {
    name: 'Thunder Dome',
    radius: 8.5,
    bowlDepth: 2.0,
    wallHeight: 2.5,
    friction: 0.975,
    wallBounce: 0.7,
    floorColor: 0x1a1a2e,
    wallColor: 0x2a2a4e,
    rimColor: 0xffcc00,
    envColor: 0x0a0a15,
    lineColor: 0xffdd33,
    centerColor: 0x998833,
    outerColor: 0x1a1a30,
    hasLava: false,
    hasIce: false,
    hasWalls: true,
    hasThunder: true,
  },
  desert: {
    name: 'Desert Colosseum',
    radius: 9.5,
    bowlDepth: 1.5,
    wallHeight: 1.8,
    friction: 0.965,
    wallBounce: 0.4,
    floorColor: 0x3e2a1a,
    wallColor: 0x5e3a2a,
    rimColor: 0xcc9944,
    envColor: 0x1a0e05,
    lineColor: 0xcc8833,
    centerColor: 0x886633,
    outerColor: 0x2a1a10,
    hasLava: false,
    hasIce: false,
    hasWalls: true,
    hasDesert: true,
  },
  galaxy: {
    name: 'Galaxy Nexus',
    radius: 11,
    bowlDepth: 1.0,
    wallHeight: 0,
    friction: 0.99,
    wallBounce: 0,
    floorColor: 0x050510,
    wallColor: 0x050510,
    rimColor: 0xff44ff,
    envColor: 0x000005,
    lineColor: 0xcc44ff,
    centerColor: 0x4422aa,
    outerColor: 0x080810,
    hasLava: false,
    hasIce: false,
    hasWalls: false,
    hasGalaxy: true,
  },
};

// Physics constants
export const PHYSICS = {
  GRAVITY: -15,
  BOWL_GRAVITY: 20,          // gravity pull toward bowl center (stronger!)
  ORBIT_FORCE: 40,           // gyroscopic precession — tangential orbit force (slightly less to let gravity win)
  MAX_SPIN: 10000,
  SPIN_DECAY_BASE: 3,        // RPM lost per second base
  COLLISION_SPIN_LOSS: 400,   // RPM lost per collision — FEEL THE IMPACT
  KNOCKBACK_FORCE: 10,       // base impulse knockback
  COLLISION_FORCE: 12,
  LAUNCH_SPIN: 10000,
  WALL_SPIN_LOSS: 80,        // spin loss from hitting walls
  BURST_THRESHOLD: 800,      // RPM below which burst can happen
  KNOCKOUT_Y: -5,            // Y position for ring-out
  CRITICAL_HIT_CHANCE: 0.12, // 12% chance per collision
  CRITICAL_HIT_MULT: 2.4,   // damage & knockback multiplier on crit
};
